import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  img: [
    {...makeRule('请上传图片', 'string')},
  ],
  url: [
    {...makeRule('请输入图片链接', 'string')},
  ],
  priority: [
    {...makeRule('请输入优先级', 'integer')},
  ],
  upshelftime: [
    {...makeRule('请选择上线时间', 'string')},
  ],
  downshelftime: [
    {...makeRule('请选择下线时间', 'string')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/flbanner/flbanner.rules.js